var map = {
	"./BE.png": "YQbz",
	"./CH.png": "OH/G",
	"./DE.png": "FVsm",
	"./ES.png": "rqr4",
	"./FR.png": "RU7J",
	"./GB.png": "HQi/",
	"./GR.png": "OfL4",
	"./IT.png": "BIx8",
	"./LU.png": "L1KN",
	"./MT.png": "vzv7",
	"./NL.png": "Istm",
	"./PT.png": "fSu7",
	"./US.png": "nRg8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "piUb";